import * as React from "react";
import { AuthService } from "./AuthService";
const authService = new AuthService();
export const AuthContext = React.createContext({
    authService: authService
});
